import { useCallback } from 'react';
import { Button, Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import { EmailEditorPageMode, RouteKey } from 'broker/enums';
import { useNavigate } from 'broker/hooks';
import { InnerPageProps } from 'broker/pages/SubmissionWorkspacePage/components/InnerPage/types';
import { SelectedTeamProductsMap } from 'broker/pages/SubmissionWorkspacePage/components/NestedViews/AddProducts/types';
import { useIsBORFlow, useWorkspaceUrls } from 'broker/pages/SubmissionWorkspacePage/hooks';

interface FooterProps {
  innerPageProps: InnerPageProps;
  selectedTeamProducts: SelectedTeamProductsMap;
}

export function Footer({ innerPageProps, selectedTeamProducts }: FooterProps) {
  const { onClose } = innerPageProps;
  const navigate = useNavigate();
  const { isBOR } = useIsBORFlow();

  const { acknowledgmentEmailUrl, emailEditorUrl } = useWorkspaceUrls();

  const onSubmitClick = useCallback(async () => {
    const selectedTeamProductIds = Object.values(selectedTeamProducts).map((teamProduct) => teamProduct.id);

    if (isBOR) {
      navigate(emailEditorUrl, {
        routeKey: RouteKey.EmailEditor,
        state: {
          selectedTeamProductIds,
          mode: EmailEditorPageMode.BorAcknowledgment,
          afterSentNavigateToWorkspace: true,
        },
      });
    } else {
      navigate(acknowledgmentEmailUrl, {
        routeKey: RouteKey.AcknowledgmentEmail,
        state: { selectedTeamProducts: Object.values(selectedTeamProducts) },
      });
    }
  }, [acknowledgmentEmailUrl, emailEditorUrl, isBOR, navigate, selectedTeamProducts]);

  return (
    <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center">
      <Stack direction="row" overflow="hidden">
        <Typography variant="body2" noWrap>
          {messages.addProductsPage.footer.getSelectedText(Object.keys(selectedTeamProducts).length)}
        </Typography>
      </Stack>
      <Stack direction="row" gap={1}>
        <Button variant="outlined" onClick={onClose}>
          {messages.buttons.back}
        </Button>
        <Button variant="contained" onClick={onSubmitClick}>
          {messages.selectProductsPage.submit}
        </Button>
      </Stack>
    </Stack>
  );
}
